import React from "react";



export default function Null () {
    return (
        <div className="Null">
            <div className='text'>
                 
       </div>
      
        
        </div>
    )
}
